import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import ApiError from '../../../../components/Errors/ApiError';
import { useUpcomingExpirations } from '../../myTeamQueries';
import { Table } from 'foundations-components/transitional/components/Table';
import { Paginator } from 'foundations-components/transitional/components/Paginator';
import { NavMarker } from 'react-rhumb';
import FormattedMessage from 'I18n/components/FormattedMessage';
import DateTableCell from '../common/DateTableCell';
import UserAvatarLink from '../common/UserAvatarLink';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import CertificationLink from '../common/CertificationLink';
import { getPaginatedPosition } from '../../utils/paginationUtils';
import EmptyOverviewCard from '../common/EmptyOverviewCard';
import { usePaginatedTable } from '../../hooks/usePaginatedTable';
import { MY_TEAM_OVERVIEW_PAGE_SIZE } from '../../../pagination';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const UpcomingExpirations = () => {
  const {
    isDesktop,
    isMobile
  } = useMediaQuery();
  const {
    upcomingExpirations,
    upcomingExpirationsLoading,
    upcomingExpirationsError
  } = useUpcomingExpirations();
  const {
    startIndex,
    paginatedData: certificationsToDisplay,
    pageCount,
    pageNumber,
    handlePageChange
  } = usePaginatedTable(upcomingExpirations, MY_TEAM_OVERVIEW_PAGE_SIZE);
  if (upcomingExpirationsLoading) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {
      grow: true,
      layout: "centered",
      minHeight: "350px",
      size: "medium"
    });
  }
  if (upcomingExpirationsError || !upcomingExpirations) {
    return /*#__PURE__*/_jsx(NavMarker, {
      name: "UPCOMING_CERTIFICATION_EXPIRATIONS_API_ERROR",
      children: /*#__PURE__*/_jsx(ApiError, {
        error: {
          status: 500
        }
      })
    });
  }
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "UPCOMING_CERTIFICATION_EXPIRATIONS_LOADED",
    children: certificationsToDisplay.length > 0 ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(Table, {
        condensed: true,
        "data-test-id": "upcoming-expirations-table",
        truncated: isMobile,
        children: [/*#__PURE__*/_jsxs("colgroup", {
          children: [/*#__PURE__*/_jsx("col", {
            width: "40%"
          }), /*#__PURE__*/_jsx("col", {
            width: "35%"
          }), /*#__PURE__*/_jsx("col", {
            width: "25%"
          })]
        }), /*#__PURE__*/_jsx("thead", {
          children: /*#__PURE__*/_jsxs("tr", {
            children: [/*#__PURE__*/_jsx("th", {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "learningCenter.myTeam.overview.teamMembers.upcomingExpirations.table.name"
              })
            }), /*#__PURE__*/_jsx("th", {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "learningCenter.myTeam.overview.teamMembers.upcomingExpirations.table.certification"
              })
            }), /*#__PURE__*/_jsx("th", {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "learningCenter.myTeam.overview.teamMembers.upcomingExpirations.table.expiration"
              })
            })]
          })
        }), /*#__PURE__*/_jsx("tbody", {
          children: certificationsToDisplay.map((cert, index) => {
            const position = getPaginatedPosition(startIndex, index);
            return /*#__PURE__*/_jsxs("tr", {
              "data-test-id": "upcoming-expiration-row",
              children: [/*#__PURE__*/_jsx("td", {
                children: /*#__PURE__*/_jsx(UserAvatarLink, {
                  displayAvatar: isDesktop,
                  position: position,
                  userEmail: cert.userEmail,
                  userId: cert.userId,
                  userName: cert.userName
                })
              }), /*#__PURE__*/_jsx("td", {
                children: /*#__PURE__*/_jsx(CertificationLink, {
                  certificationId: cert.certificationId,
                  certificationName: cert.certificationName,
                  position: position,
                  showIcon: false
                })
              }), /*#__PURE__*/_jsx(DateTableCell, {
                value: cert.expiresAt
              })]
            }, `${cert.userId}-${cert.certificationId}-${index}`);
          })
        })]
      }), /*#__PURE__*/_jsx(Paginator, {
        onPageChange: handlePageChange,
        page: pageNumber,
        pageCount: pageCount,
        showButtonLabels: false
      })]
    }) : /*#__PURE__*/_jsxs(EmptyOverviewCard, {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.myTeam.overview.certifications.noCertifications"
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.myTeam.overview.certifications.findContent"
      })]
    })
  });
};
export default UpcomingExpirations;